import { Box, Flex, Image } from "@chakra-ui/react";
import mapEmptyStateImage from '../../../digital-sales-room/dsr-action-list/styles/images/map-empty-state.svg'
import LaunchdeckButton from "../../../global/components/helper-components/components/LaunchdeckButton";


export default function PublicDsrMapSignupPrompt({ handleOpenSignupOrLoginModal }) {

  return (
    <>
      <Flex mt='2em' justify='center' align='center' py='2.75em' border='1px solid #E5EAEF' rounded='0.5em' bg='white'>

        <Flex direction='column' justify='center' align='center'>
          <Image src={mapEmptyStateImage} alt="Empty Mutual Action Plan Page" />

          <Box fontWeight='400' fontSize='0.875em' lineHeight='1.2em' color='gray.500' p='1.5em 1em' textAlign='center'>
            The Room owner allows only its members to view the plan
          </Box>

          <Flex justify='center'>
            <LaunchdeckButton bg='brand.500' color='white' px='2.5em' w={["100%", "auto"]} onClick={() => handleOpenSignupOrLoginModal()} label='Join Room' />
          </Flex>
        </Flex>

      </Flex>
    </>
  );

}